"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExportConfigurationHandler = useExportConfigurationHandler;
const FunctionClient_1 = require("@juvare/platform-sdk-js/FunctionClient");
const StorageClient_1 = require("@juvare/platform-sdk-js/StorageClient");
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const react_1 = __importDefault(require("react"));
const ExportConfigurationDialog_1 = require("../components/ExportConfigurationDialog");
const exportConfiguration_1 = require("../utils/exportConfiguration");
function useExportConfigurationHandler(params) {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const [open, setOpen] = react_1.default.useState(false);
    const initSelectedFeatures = react_1.default.useCallback(() => Object.fromEntries(params.features.map((feature) => [feature, true])), [params.features]);
    const initSelectedClassifiers = react_1.default.useCallback(() => Object.fromEntries((params.classifiers ?? []).map(({ entityName }) => [entityName, true])), [params.classifiers]);
    const [selectedFeatures, setSelectedFeatures] = react_1.default.useState(initSelectedFeatures);
    const [selectedClassifiers, setSelectedClassifiers] = react_1.default.useState(initSelectedClassifiers);
    const handleExportButtonClick = react_1.default.useCallback(() => setOpen(true), []);
    const handleDialogClose = react_1.default.useCallback(() => {
        setOpen(false);
    }, []);
    const handleDialogClosed = react_1.default.useCallback(() => {
        setSelectedFeatures(initSelectedFeatures());
        setSelectedClassifiers(initSelectedClassifiers());
        setExportProgress(undefined);
    }, [initSelectedFeatures, initSelectedClassifiers]);
    const [exportProgress, setExportProgress] = react_1.default.useState();
    const cancelFunctionRef = react_1.default.useRef(undefined);
    const handleDialogExport = react_1.default.useCallback(() => {
        cancelFunctionRef.current = (0, exportConfiguration_1.exportConfiguration)({
            t,
            features: params.features.filter((feature) => selectedFeatures[feature]),
            classifiers: (params.classifiers ?? []).filter((classifier) => selectedClassifiers[classifier.entityName]),
            progressCallback: setExportProgress,
            getFunctionClient: () => new FunctionClient_1.FunctionClient(),
            getStorageClient: (entityName) => new StorageClient_1.StorageClient(entityName),
        }).cancel;
    }, [t, params.classifiers, params.features, selectedClassifiers, selectedFeatures]);
    const handleDialogCancel = react_1.default.useCallback(() => {
        cancelFunctionRef.current?.();
    }, []);
    const exportDialog = (react_1.default.createElement(ExportConfigurationDialog_1.ExportConfigurationDialog, { features: params.features, classifiers: params.classifiers, open: open, onClose: handleDialogClose, onClosed: handleDialogClosed, onExport: handleDialogExport, onCancel: handleDialogCancel, selectedFeatures: selectedFeatures, setSelectedFeatures: setSelectedFeatures, selectedClassifiers: selectedClassifiers, setSelectedClassifiers: setSelectedClassifiers, exportProgress: exportProgress }));
    return { handleExportButtonClick, exportDialog };
}
